class LpStickyAddToCart extends HTMLElement {
  connectedCallback() {
    const targetSelector = this.dataset.target;
    const target = targetSelector ? document.querySelector(targetSelector) : null;

    if (!target) return;

    this.#observer = new IntersectionObserver(
      ([entry]) => {
        this.dataset.visible = String(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );

    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  /** @type {IntersectionObserver | undefined} */
  #observer;
}

if (!customElements.get('lp-sticky-add-to-cart')) {
  customElements.define('lp-sticky-add-to-cart', LpStickyAddToCart);
}
